(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@fiverr/globals"), require("react"), require("prop-types"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["@fiverr/globals", "react", "prop-types", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["OutOfOffice"] = factory(require("@fiverr/globals"), require("react"), require("prop-types"), require("react-dom"));
	else
		root["OutOfOffice"] = factory(root["@fiverr/globals"], root["React"], root["PropTypes"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_E4I8__, __WEBPACK_EXTERNAL_MODULE_Jmof__, __WEBPACK_EXTERNAL_MODULE_T9WB__, __WEBPACK_EXTERNAL_MODULE_wLXD__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://npm-assets.fiverrcdn.com/assets/@fiverr/out_of_office/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "lVK7");
/******/ })
/************************************************************************/
/******/ ({

/***/ "9uwH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DuR2":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "E4I8":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_E4I8__;

/***/ }),

/***/ "EODv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jmof":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_Jmof__;

/***/ }),

/***/ "T9WB":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_T9WB__;

/***/ }),

/***/ "Tjxa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UTxY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aJ9I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eIBB":
/***/ (function(module, exports) {

module.exports = {"out_of_office":{"general":{"edit":"Edit"},"popup":{"title":"Out of Office Mode","returning_date":"Returning Date","optional":"Optional","why_vacation":{"title":"Why?","options":{"select":"Select","on_vacation":"I'm going on vacation","overbooked":"I'm overbooked","other":"Other"}},"leave_message":{"title":"Leave a message for buyers","on_vacation":"I'm on vacation, be back soon","overbooked":"I'm overbooked, be back soon","other":"I’m unavailable, be back soon"},"allow_new_buyers":"Allow new buyers to contact me. I realize this can affect my response rate and avg. response time","date_invalid":"Please enter a valid date"},"banner":{"buyer":{"is_out":"%{username} is Out of Office","until":" until %{endDate}","meantime":"in the meantime, you can ","contact":"contact","notify":"You will be notified when %{username} gets back","notify_me_1":"Click ","notify_me_2":" to be notified when %{username} gets back"},"seller":{"you_are_out":"You are now Out of Office","until":" until %{endDate}","your_gigs":"Your Gigs will remain inactive until:"}},"error":{"general":"Something went wrong, please try again"}}}

/***/ }),

/***/ "fCd0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iCOP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Popup", function() { return Popup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("Jmof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("wLXD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OutOfOffice__ = __webpack_require__("vUMG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fPopup_index__ = __webpack_require__("r0qR");




var componentElm = typeof global.document !== 'undefined' && global.document.getElementById('OutOfOffice-component');

// fPopup global
var Popup = global.fPopup ? global.fPopup.default : __WEBPACK_IMPORTED_MODULE_3__fPopup_index__["a" /* default */];

if (componentElm) {
    var initialState = global.window.initialData.OutOfOffice;

    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__OutOfOffice__["a" /* default */], initialState), componentElm);
}

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_2__OutOfOffice__["a" /* default */]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "p6AB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r0qR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React","var":"React"}
var external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__ = __webpack_require__("Jmof");
var external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__);

// EXTERNAL MODULE: external {"commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom","root":"ReactDOM","var":"ReactDOM"}
var external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM__ = __webpack_require__("wLXD");
var external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM__);

// EXTERNAL MODULE: ./src/fPopup/popup_types/base/popup-base.scss
var popup_base = __webpack_require__("9uwH");
var popup_base_default = /*#__PURE__*/__webpack_require__.n(popup_base);

// CONCATENATED MODULE: ./src/fPopup/popup_types/base/index.js



function base(_ref) {
    var popupClass = _ref.popupClass,
        closePopup = _ref.closePopup,
        title = _ref.title,
        children = _ref.children;

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        { className: popupClass + ' centered' },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'header',
            null,
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'a',
                { href: '#!', className: 'btn-close', onClick: closePopup },
                '\xD7'
            ),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'h2',
                null,
                title
            )
        ),
        children
    );
}

/* harmony default export */ var popup_types_base = (base);
// CONCATENATED MODULE: ./src/fPopup/popup_types/clean-canvas/index.js


function cleanCanvas(_ref) {
    var popupClass = _ref.popupClass,
        children = _ref.children;

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        { className: '' + popupClass },
        children
    );
}

/* harmony default export */ var clean_canvas = (cleanCanvas);
// EXTERNAL MODULE: ./src/fPopup/popup_types/overlay-mobile/popup-overlay-mobile.scss
var popup_overlay_mobile = __webpack_require__("p6AB");
var popup_overlay_mobile_default = /*#__PURE__*/__webpack_require__.n(popup_overlay_mobile);

// CONCATENATED MODULE: ./src/fPopup/popup_types/overlay-mobile/index.js



function overlayMobile(_ref) {
    var closePopup = _ref.closePopup,
        title = _ref.title,
        popupClass = _ref.popupClass,
        children = _ref.children;

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        { className: popupClass },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'header',
            null,
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'a',
                { href: '#!', className: 'btn-close', onClick: closePopup },
                '\xD7'
            ),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'h2',
                null,
                title
            )
        ),
        children
    );
}

/* harmony default export */ var overlay_mobile = (overlayMobile);
// EXTERNAL MODULE: ./src/fPopup/popup_types/lean/popup-lean.scss
var popup_lean = __webpack_require__("aJ9I");
var popup_lean_default = /*#__PURE__*/__webpack_require__.n(popup_lean);

// CONCATENATED MODULE: ./src/fPopup/popup_types/lean/index.js



function lean(_ref) {
    var popupClass = _ref.popupClass,
        children = _ref.children;

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        { className: '' + popupClass },
        children
    );
}

/* harmony default export */ var popup_types_lean = (lean);
// EXTERNAL MODULE: ./src/fPopup/popup_types/mobile-sticky/popup-mobile-sticky.scss
var popup_mobile_sticky = __webpack_require__("UTxY");
var popup_mobile_sticky_default = /*#__PURE__*/__webpack_require__.n(popup_mobile_sticky);

// CONCATENATED MODULE: ./src/fPopup/popup_types/mobile-sticky/index.js



function MobileSticky(_ref) {
    var popupClass = _ref.popupClass,
        children = _ref.children,
        closePopup = _ref.closePopup;


    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        { className: popupClass },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'header',
            null,
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'a',
                { href: '#!', className: 'btn-close', onClick: closePopup },
                '\xD7'
            )
        ),
        children
    );
}

/* harmony default export */ var mobile_sticky = (MobileSticky);
// CONCATENATED MODULE: ./src/fPopup/popup_types/index.js






var types = {
    base: popup_types_base, // standard looking popup
    'clean-canvas': clean_canvas, // no markup at all. just a floating container. use for custom configuration popups
    lean: popup_types_lean, // clean popup, not much styling. use for long content. white background.
    'overlay-mobile': overlay_mobile, // full screen popup for mobile pages
    'mobile-sticky': mobile_sticky // sticky top/bottom mobile popup
};

/* harmony default export */ var popup_types = (types);
// EXTERNAL MODULE: ./src/fPopup/style.scss
var style = __webpack_require__("Tjxa");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./src/fPopup/index.js
/* unused harmony export onModalClick */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var WRAPPER_CLASS = 'f-popup-wrapper';

function onModalClick(e, modalClose, closePopup) {

    if (!modalClose) {
        return;
    }

    if (e.target.className.indexOf(WRAPPER_CLASS) > -1) {
        closePopup();
    }
}

function PopupGenerator(_ref) {
    var closePopup = _ref.closePopup,
        _ref$name = _ref.name,
        name = _ref$name === undefined ? '' : _ref$name,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? '' : _ref$title,
        children = _ref.children,
        _ref$modalVisible = _ref.modalVisible,
        modalVisible = _ref$modalVisible === undefined ? true : _ref$modalVisible,
        _ref$modalClose = _ref.modalClose,
        modalClose = _ref$modalClose === undefined ? true : _ref$modalClose,
        _ref$brighten = _ref.brighten,
        brighten = _ref$brighten === undefined ? false : _ref$brighten,
        _ref$layout = _ref.layout,
        layout = _ref$layout === undefined ? 'base' : _ref$layout;

    var modalClass = modalClose || modalVisible ? ' modal' : '';

    if (modalVisible) {
        if (brighten) {
            modalClass += ' brighten';
        } else {
            modalClass += ' darken';
        }
    }

    var wrapperClass = '' + WRAPPER_CLASS + modalClass,
        popupClass = 'popup-' + layout + ' popup-' + name,
        type = popup_types.hasOwnProperty(layout) ? layout : 'base';

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        { className: wrapperClass, onClick: function onClick(e) {
                return onModalClick(e, modalClose, closePopup);
            } },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'div',
            { className: 'scroller' },
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'button',
                { className: 'btn-close outside-close', onClick: closePopup },
                '\xD7'
            ),
            popup_types[type]({ popupClass: popupClass, closePopup: closePopup, title: title, children: children })
        )
    );
}

var fPopup_Popup = function (_React$Component) {
    _inherits(Popup, _React$Component);

    function Popup() {
        _classCallCheck(this, Popup);

        var _this = _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this));

        _this.onEscape = _this.onEscape.bind(_this);
        return _this;
    }

    _createClass(Popup, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.setEntryPoint(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            this.setEntryPoint(props);
        }
    }, {
        key: 'setEntryPoint',
        value: function setEntryPoint(props) {
            var _this2 = this;

            if (props.isOpen) {

                var layout = props.layout || 'base';

                if (!this.entryPoint) {
                    this.createEntryPoint(props.name, layout);
                }

                if (props.noScroll && document) {
                    document.body.classList.add('no-scroll');
                }

                window.addEventListener('keyup', this.onEscape);

                this.renderPopup(props);
            } else {

                this.closePopup = props.closePopup;

                if (this.entryPoint) {
                    this.entryPoint.classList.remove('shown');
                }
                setTimeout(function () {
                    if (_this2.entryPoint && document) {
                        external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM___default.a.unmountComponentAtNode(_this2.entryPoint);
                        document.body.removeChild(_this2.entryPoint);
                        document.body.classList.remove('no-scroll');
                    }
                    delete _this2.entryPoint;
                }, 500);
            }
        }
    }, {
        key: 'onEscape',
        value: function onEscape(e) {

            if (e.keyCode === 27 || e.which === 27 || e.code === 'Escape' || e.key === 'Escape') {
                this.closePopup && this.closePopup();
                window.removeEventListener('keyup', this.onEscape);
            }
        }
    }, {
        key: 'createEntryPoint',
        value: function createEntryPoint(name, layout) {
            var _this3 = this;

            if (document) {
                this.entryPoint = document.createElement('div');
                this.entryPoint.setAttribute('class', 'popup-root ' + name + ' ' + layout);
                document.body.appendChild(this.entryPoint);
                setTimeout(function () {
                    return _this3.entryPoint.classList.add('shown');
                }, 0);
            }
        }
    }, {
        key: 'renderPopup',
        value: function renderPopup(props) {
            var Generator = props.customGenerator || PopupGenerator;

            external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM___default.a.unstable_renderSubtreeIntoContainer(props.parent, external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(Generator, props), this.entryPoint);
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return Popup;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.Component);

/* harmony default export */ var fPopup = __webpack_exports__["a"] = (fPopup_Popup);

/***/ }),

/***/ "tBbN":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.fit=t():e.fit=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){e.exports=n(57)},function(e,t,n){"use strict";e.exports=n(92)},function(e,t,n){"use strict";function r(e,t,n,r,a,u,i,l){if(o(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var s=[n,r,a,u,i,l],f=0;c=new Error(t.replace(/%s/g,function(){return s[f++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var o=function(e){};e.exports=r},function(e,t,n){"use strict";function r(e){return void 0!==e.ref}function o(e){return void 0!==e.key}var a=n(6),u=n(22),i=(n(5),n(25),Object.prototype.hasOwnProperty),l=n(23),c={key:!0,ref:!0,__self:!0,__source:!0},s=function(e,t,n,r,o,a,u){var i={$$typeof:l,type:e,key:t,ref:n,props:u,_owner:a};return i};s.createElement=function(e,t,n){var a,l={},f=null,p=null,d=null,h=null;if(null!=t){r(t)&&(p=t.ref),o(t)&&(f=""+t.key),d=void 0===t.__self?null:t.__self,h=void 0===t.__source?null:t.__source;for(a in t)i.call(t,a)&&!c.hasOwnProperty(a)&&(l[a]=t[a])}var v=arguments.length-2;if(1===v)l.children=n;else if(v>1){for(var y=Array(v),m=0;m<v;m++)y[m]=arguments[m+2];l.children=y}if(e&&e.defaultProps){var b=e.defaultProps;for(a in b)void 0===l[a]&&(l[a]=b[a])}return s(e,f,p,d,h,u.current,l)},s.createFactory=function(e){var t=s.createElement.bind(null,e);return t.type=e,t},s.cloneAndReplaceKey=function(e,t){var n=s(e.type,t,e.ref,e._self,e._source,e._owner,e.props);return n},s.cloneElement=function(e,t,n){var l,f=a({},e.props),p=e.key,d=e.ref,h=e._self,v=e._source,y=e._owner;if(null!=t){r(t)&&(d=t.ref,y=u.current),o(t)&&(p=""+t.key);var m;e.type&&e.type.defaultProps&&(m=e.type.defaultProps);for(l in t)i.call(t,l)&&!c.hasOwnProperty(l)&&(void 0===t[l]&&void 0!==m?f[l]=m[l]:f[l]=t[l])}var b=arguments.length-2;if(1===b)f.children=n;else if(b>1){for(var g=Array(b),_=0;_<b;_++)g[_]=arguments[_+2];f.children=g}return s(e.type,p,d,h,v,y,f)},s.isValidElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===l},e.exports=s},function(e,t){"use strict";function n(e){return function(){return e}}var r=function(){};r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){"use strict";var r=n(4),o=r;e.exports=o},function(e,t){/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
"use strict";function n(e){if(null===e||void 0===e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}function r(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},n=0;n<10;n++)t["_"+String.fromCharCode(n)]=n;var r=Object.getOwnPropertyNames(t).map(function(e){return t[e]});if("0123456789"!==r.join(""))return!1;var o={};return"abcdefghijklmnopqrst".split("").forEach(function(e){o[e]=e}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},o)).join("")}catch(e){return!1}}var o=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable;e.exports=r()?Object.assign:function(e,t){for(var r,i,l=n(e),c=1;c<arguments.length;c++){r=Object(arguments[c]);for(var s in r)a.call(r,s)&&(l[s]=r[s]);if(o){i=o(r);for(var f=0;f<i.length;f++)u.call(r,i[f])&&(l[i[f]]=r[i[f]])}}return l}},function(e,t){"use strict";function n(e){for(var t=arguments.length-1,n="Minified React error #"+e+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant="+e,r=0;r<t;r++)n+="&args[]="+encodeURIComponent(arguments[r+1]);n+=" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";var o=new Error(n);throw o.name="Invariant Violation",o.framesToPop=1,o}e.exports=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=Object.keys(e);return t.length?t.sort(function(t,n){return e[n].sortId-e[t].sortId}):t}function a(e){var t="translateY("+p*e+"px)";return{transform:t}}function u(e){var t=Object.keys(e).length;return{height:p*t+"px"}}function i(e){var t=e.attachments,n=e.onAbort,r=e.autoGrow,i=o(t),l=u(t),s="fit-attachment-list"+(r?" fixed":"");return i.length?c.default.createElement("ul",{className:s,style:l},i.map(function(e,r){var o=a(r);return c.default.createElement(f.default,{key:e,style:o,file:t[e],onAbort:n})})):null}Object.defineProperty(t,"__esModule",{value:!0});var l=n(1),c=r(l);n(66);var s=n(26),f=r(s),p=50;t.default=i},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.name,n=e.onAttach,r=e.text,o=e.isSingle,a="fit-btn-attachment",i=!o;return r&&(a+=" btn-standard btn-white-grad"),u.default.createElement("label",{className:a},r,u.default.createElement("input",{type:"file",name:t,onChange:function(e){return n(e.target.files)},multiple:i}))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(69),o.propTypes={name:u.default.PropTypes.string.isRequired,onAttach:u.default.PropTypes.func.isRequired,text:u.default.PropTypes.string,isSingle:u.default.PropTypes.bool},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.error,n=e.icon;if(!t||0===Object.keys(t).length||!t.title&&!t.message)return null;var r=n?" icon ":"";return u.default.createElement("div",{className:"fit-simple-error "+r},t.title&&u.default.createElement("strong",null,t.title),t.message&&u.default.createElement("small",null,t.message))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(75),t.default=o},function(e,t){"use strict";function n(e){switch(e){case"small":return"btn-standard";case"medium":return"btn-lrg-standard lesspad";case"large":return"btn-lrg-standard";case"full-width":return"btn-lrg-standard full-width";default:return"btn-standard"}}Object.defineProperty(t,"__esModule",{value:!0}),t.getSizeClass=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){if(!e.text)return e.children;var t={"data-hint":e.text||"",className:"hint--"+(e.position||"top")};return u.default.createElement("span",t,e.children)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(1),f=r(s),p=n(10),d=r(p),h=function(e){function t(e){a(this,t);var n=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={validationError:!1},n.handleChange=n.handleChange.bind(n),n}return i(t,e),c(t,[{key:"handleChange",value:function(e){var t=this,n=e.target.value;this.setState(function(){var e=t.props.validate&&t.props.validate(n);return{validationError:e}})}},{key:"render",value:function(){var e=this.state.validationError,t=this.props,n=t.id,r=t.label,a=t.prefix,u=t.suffix,i=o(t,["id","label","prefix","suffix"]);return f.default.createElement("div",{className:"fit-input"},f.default.createElement("label",{htmlFor:n},r,f.default.createElement("div",{className:"input-wrapper","data-prefix":a,"data-suffix":u},f.default.createElement("input",l({onChange:this.handleChange,className:e?"with-error":""},i)))),!!e&&f.default.createElement(d.default,{error:e}))}}]),t}(s.Component);t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.updateCurrentPage,n=e.currentPage,r=e.totalPages,o=[],a=1;for(a;a<=r;a++)a===n?o.push(i.default.createElement("a",{href:"#",className:"current-page",key:a},a)):o.push(i.default.createElement("a",{href:"#",onClick:function(){return t(a)},key:a},a));return i.default.createElement("ul",null,o)}function a(e){var t=e.updateCurrentPage,n=e.currentPage,r=e.totalPages;return r<=1?null:i.default.createElement("nav",{className:"pagination fit-pagination"},i.default.createElement("div",{className:"pagination-range"},i.default.createElement(o,{updateCurrentPage:t,currentPage:n,totalPages:r})))}Object.defineProperty(t,"__esModule",{value:!0});var u=n(1),i=r(u);n(74),t.default=a},function(e,t){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";return{title:e,message:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n},function(e,t,n){"use strict";function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}function o(e){return e&&e.__esModule?e:{default:e}}function a(e){var t=e.icon,n=e.width,r=void 0===n?20:n,o=e.height,a=void 0===o?20:o,u=e.color,l=void 0===u?"black":u;if(!t)return null;var s="fit-svg-icon "+t+" "+l;return i.default.createElement("svg",{className:s,viewBox:"0 0 1792 1792",xmlns:"http://www.w3.org/2000/svg",width:r,height:a},i.default.createElement("path",{d:c[t]}))}Object.defineProperty(t,"__esModule",{value:!0});var u=n(1),i=o(u);n(77);var l=n(43),c=r(l);t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function i(e){var t=e.extensions;return t?f.default.createElement("div",{className:"textarea-extensions"},t):null}function l(e){var t=e.label;return t?f.default.createElement("div",null,t):null}Object.defineProperty(t,"__esModule",{value:!0});var c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(1),f=r(s),p=n(30),d=r(p),h=n(10),v=r(h);n(80);var y=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;return function(){return e++}},m=y(),b=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={validationError:!1,value:n.props.value||""},n.id="fit-textarea-"+m(),n.handleChange=n.handleChange.bind(n),n}return u(t,e),c(t,[{key:"componentWillReceiveProps",value:function(e){var t=this.state.value,n=e.value||t,r=n===t?t:n;this.setState({value:r})}},{key:"handleChange",value:function(){var e=this,t=this.textarea.value;this.setState(function(n){var r=e.reachedMaxLength(t)?n.value:t;return e.props.onChange&&e.props.onChange(r),{value:r,validationError:e.props.validate&&e.props.validate(t)}})}},{key:"reachedMaxLength",value:function(e){var t=this.props.maxLength;return!!t&&e.length>t}},{key:"render",value:function(){var e=this,t=this.state,n=t.validationError,r=t.value,o=this.props,a=o.maxLength,u=o.name,c=o.children,s=o.placeholder,p=o.isInvalid,h=o.label,y=o.hideCharCount,m=o.onBlur,b=r.length,g=n||p?"invalid":"",_="fit-textarea"+(h?" has-label":"");return f.default.createElement("div",{className:_},f.default.createElement("textarea",{name:u,className:g,id:this.id,value:r,placeholder:s,onChange:this.handleChange,onBlur:m?m:function(){return!0},ref:function(t){return e.textarea=t}}),f.default.createElement("label",{htmlFor:this.id},f.default.createElement(l,{label:h})),f.default.createElement("footer",null,!y&&f.default.createElement(d.default,{currentCount:b,maxCount:a}),f.default.createElement(i,{extensions:c})),!!n&&f.default.createElement(v.default,{error:n}))}}]),t}(s.Component);t.default=b},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(60),a=r(o);t.default=a.default},function(e,t,n){"use strict";var r={};e.exports=r},function(e,t){"use strict";var n="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=n},function(e,t,n){"use strict";function r(e,t,n){this.props=e,this.context=t,this.refs=c,this.updater=n||l}function o(e,t,n){this.props=e,this.context=t,this.refs=c,this.updater=n||l}function a(){}var u=n(7),i=n(6),l=n(24),c=(n(25),n(19));n(2),n(99);r.prototype.isReactComponent={},r.prototype.setState=function(e,t){"object"!=typeof e&&"function"!=typeof e&&null!=e?u("85"):void 0,this.updater.enqueueSetState(this,e),t&&this.updater.enqueueCallback(this,t,"setState")},r.prototype.forceUpdate=function(e){this.updater.enqueueForceUpdate(this),e&&this.updater.enqueueCallback(this,e,"forceUpdate")};a.prototype=r.prototype,o.prototype=new a,o.prototype.constructor=o,i(o.prototype,r.prototype),o.prototype.isPureReactComponent=!0,e.exports={Component:r,PureComponent:o}},function(e,t){"use strict";var n={current:null};e.exports=n},function(e,t){"use strict";var n="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103;e.exports=n},function(e,t,n){"use strict";function r(e,t){}var o=(n(5),{isMounted:function(e){return!1},enqueueCallback:function(e,t){},enqueueForceUpdate:function(e){r(e,"forceUpdate")},enqueueReplaceState:function(e,t){r(e,"replaceState")},enqueueSetState:function(e,t){r(e,"setState")}});e.exports=o},function(e,t,n){"use strict";var r=!1;e.exports=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.onAbort,n=e.file,r=e.style,o=void 0===r?{}:r,a=n.error,i=n.extension,c=n.progress,s=n.fileName,f=n.fileSize,p=n.loaded,d=p===!0?" done":"",h="",v=f;a&&(h=" file-error",v=a);var y="fit-attachment"+d+h;return u.default.createElement("li",{style:o,className:y},u.default.createElement("div",{className:"file-progress"},u.default.createElement(l.default,{progress:c})),u.default.createElement("div",{className:"file-info"},u.default.createElement("strong",null,u.default.createElement("span",{className:"name"},s),u.default.createElement("span",null,i)),u.default.createElement("small",null,v)),u.default.createElement("a",{href:"#!",className:"abort",onClick:function(){return t(n.id)}}))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a),i=n(18),l=r(i);n(65),t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.src,n=e.size,r=void 0===n?24:n;return t?(t=t.startsWith("http")?'<img src="'+t+'"/>':t,u.default.createElement("span",{className:"fit-avatar s"+r,dangerouslySetInnerHTML:{__html:t}})):null}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(67),t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.index,n=e.title,r=e.url,o=e.crumbClass;return r?u.default.createElement("a",{href:r,"data-index":t,className:o},n):u.default.createElement("span",{"data-index":t,className:o},n)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(68);var i=function(e){var t=e.crumbsList,n=e.currentCrumb,r=void 0===n?"1":n;return t.length?u.default.createElement("ul",{className:"fit-breadcrumbs-list"},t.map(function(e,t){var n=t+1,a=n===parseInt(r,10),i=a?"current":null,l=a?null:e.url;return u.default.createElement("li",{key:t},u.default.createElement(o,{index:n,title:e.title,url:l,crumbClass:i}))})):null};i.propTypes={crumbsList:u.default.PropTypes.array.isRequired},t.default=i},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.text,n=e.theme,r=e.size,a=e.type,i=e.disabled,s=e.inProgress,f=e.className,p=o(e,["text","theme","size","type","disabled","inProgress","className"]),d=(0,c.getSizeClass)(r),h=s?"in-progress":"",v=i?"disabled":"",y=[d,n,h,v,f].filter(function(e){return!!e}).join(" ");return l.default.createElement("button",u({className:y,type:a,disabled:i},p),t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(1),l=r(i),c=n(11);a.defaultProps={size:"small",text:"",theme:"",type:"button",disabled:!1,inProgress:!1,className:""},t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.currentCount,n=void 0===t?0:t,r=e.maxCount,o=void 0===r?0:r;return u.default.createElement("span",{className:"fit-char-count"},u.default.createElement("strong",null,n)," / ",u.default.createElement("span",{className:"max"},o))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);o.propTypes={currentCount:u.default.PropTypes.number,maxCount:u.default.PropTypes.number},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.caption,n=o(e,["caption"]);return l.default.createElement("label",{className:"fit-checkbox fake-check-black check-text"},l.default.createElement("input",u({type:"checkbox"},n)),l.default.createElement("span",{className:"chk-img"}),t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(1),l=r(i);a.propTypes={caption:l.default.PropTypes.any},t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){function t(e){var t=c,n=t.checked;n&&(e&&e.preventDefault(),t.checked=!1)}var n=e.group,r=e.children,o=l(),a="collapsable-"+n,i=a+"-"+o,c=void 0;return u.default.createElement("section",{className:"fit-collapsable"},u.default.createElement("input",{type:"radio",name:a,id:i,ref:function(e){return c=e}}),u.default.createElement("label",{htmlFor:i,onClick:t},r[0]()),u.default.createElement("article",null,r[1](t)))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(70);var i=function(e){return function(){return e++}},l=i(1);t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(1),f=r(s),p=n(11),d=function(e){function t(e){a(this,t);var n=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={disabled:n.props.disabled||!1,inProgress:n.props.inProgress||!1},n}return i(t,e),c(t,[{key:"render",value:function(){var e=this.state,t=e.disabled,n=e.inProgress,r=this.props,a=r.text,u=void 0===a?"":a,i=r.theme,c=void 0===i?"":i,s=r.size,d=r.href,h=void 0===d?"#":d,v=o(r,["text","theme","size","href"]),y=n?" in-progress":"",m=t?" disabled":"",b=(0,p.getSizeClass)(s),g=b+" "+c+" "+m+" "+y;return f.default.createElement("a",l({href:h,className:g},v),u)}}]),t}(s.Component);t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(1),s=r(c),f=n(13),p=r(f),d=n(15),h=r(d);n(71);var v=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.inputValidation=n.inputValidation.bind(n),n}return u(t,e),l(t,[{key:"inputValidation",value:function(e){return""===e||Number(e)>=0?this.props.validate&&this.props.validate(e):this.props.defaultError||(0,h.default)()}},{key:"render",value:function(){var e=this.props.symbol;return s.default.createElement("div",{className:"fit-currency"},s.default.createElement(p.default,i({},this.props,{validate:this.inputValidation,prefix:e})))}}]),t}(c.Component);t.default=v},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(1),c=r(l),s=n(14),f=r(s);n(72);var p=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={currentPage:e.currentPage||1,perPage:e.perPage||2},n.updateCurrentPage=n.updateCurrentPage.bind(n),n}return u(t,e),i(t,[{key:"updateCurrentPage",value:function(e){this.setState({currentPage:e})}},{key:"filterPerPage",value:function(e){var t=this.state,n=t.perPage,r=t.currentPage,o=n*r,a=(r-1)*n;return e.slice(a,o)}},{key:"render",value:function(){var e=this.state,t=e.currentPage,n=e.perPage,r=this.props,o=r.tableHeader,a=r.data,u=Math.ceil(a.length/n);return c.default.createElement("table",{className:"easy-table"},c.default.createElement("thead",null,c.default.createElement("tr",null,o.map(function(e,t){return c.default.createElement("th",{key:t},e.title)}))),c.default.createElement("tbody",null,this.filterPerPage(a).map(function(e,t){return c.default.createElement("tr",{key:t},o.map(function(t,n){return c.default.createElement("td",{key:n},"actions"===t.assignTo&&t.actions(e.id),"actions"!==t.assignTo&&e[t.assignTo])}))})),u&&c.default.createElement("tfoot",null,c.default.createElement("tr",null,c.default.createElement("td",{colSpan:o.length},c.default.createElement(f.default,{totalPages:u,currentPage:t,updateCurrentPage:this.updateCurrentPage})))))}}]),t}(l.Component);t.default=p},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){function t(e){e.target.parentElement.remove(),o&&o()}var n=e.theme,r=e.title,o=e.callback,a=e.closeButton,i=e.children;return u.default.createElement("div",{className:"fit-pagealert "+n},a&&u.default.createElement("a",{href:"#",className:"btn-close",onClick:t},"×"),u.default.createElement("i",{className:"icon"}),u.default.createElement("div",{className:"content-wrapper"},u.default.createElement("h3",null,r),u.default.createElement("div",{className:"content"},i)))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(73),o.propTypes={theme:u.default.PropTypes.string.isRequired,title:u.default.PropTypes.string.isRequired,callback:u.default.PropTypes.func,closeButton:u.default.PropTypes.bool},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.caption,n=o(e,["caption"]);return l.default.createElement("label",{className:"fit-radio fake-radio-black radio-text"},l.default.createElement("input",u({type:"radio"},n)),l.default.createElement("span",{className:"radio-img"}),t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(1),l=r(i);a.propTypes={caption:l.default.PropTypes.any},t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){for(var t=e.value,n=void 0===t?0:t,r=e.max,o=void 0===r?5:r,u=e.shape,l=void 0===u?"star":u,s=e.width,f=void 0===s?20:s,p=e.height,d=void 0===p?20:p,h=e.color,v=void 0===h?"black":h,y={color:v,width:f,height:d},m=Math.round(2*n)/2,b=[],g=0;g<o;g++){var _="full_"+l;g+.5===m?_="o_half_"+l:g>=Math.floor(m)&&(_="o_"+l),b.push(i.default.createElement(c.default,a({},y,{icon:_})))}return i.default.createElement("div",{className:"fit-rating"},b)}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=n(1),i=r(u),l=n(16),c=r(l);t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.children,n=e.label,r=o(e,["children","label"]);return i.default.createElement("label",null,n,i.default.createElement("select",r,t))}Object.defineProperty(t,"__esModule",{value:!0});var u=n(1),i=r(u);t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.children,n=o(e,["children"]);return i.default.createElement("option",n,t)}Object.defineProperty(t,"__esModule",{value:!0});var u=n(1),i=r(u);t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(1),c=r(l),s=n(8),f=r(s),p=n(9),d=r(p),h=n(12),v=r(h),y=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={attachments:n.props.attachments||{}},n}return u(t,e),i(t,[{key:"componentWillReceiveProps",value:function(e){this.setState({attachments:e.attachments||{}})}},{key:"render",value:function(){var e=this.state.attachments,t=this.props,n=t.name,r=t.onAttach,o=t.onAbort,a=t.text,u=t.hint;return c.default.createElement("div",{className:"fit-simple-uploader"},c.default.createElement(v.default,u,c.default.createElement(d.default,{name:n,text:a,onAttach:r})),c.default.createElement(f.default,{attachments:e,onAbort:o,autoGrow:!0}))}}]),t}(l.Component);t.default=y},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.children,n=e.caption,r=e.classes,a=o(e,["children","caption","classes"]),i=r?" "+r:"";return l.default.createElement("span",u({className:"fit-status"+i},a),n?n:t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(1),l=r(i);n(76),t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.refresh=t.clock_o=t.check=t.o_heart=t.full_heart=t.o_half_star=t.o_star=t.full_star=void 0;var o=n(47),a=r(o),u=n(50),i=r(u),l=n(48),c=r(l),s=n(46),f=r(s),p=n(49),d=r(p),h=n(44),v=r(h),y=n(45),m=r(y),b=n(51),g=r(b);t.full_star=a.default,t.o_star=i.default,t.o_half_star=c.default,t.full_heart=f.default,t.o_heart=d.default,t.check=v.default,t.clock_o=m.default,t.refresh=g.default},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1024 544v448q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-352q0-14 9-23t23-9h64q14 0 23 9t9 23zm416 352q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zm224 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M896 1664q-26 0-44-18l-624-602q-10-8-27.5-26t-55.5-65.5-68-97.5-53.5-121-23.5-138q0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344q0 221-229 450l-623 600q-18 18-44 18z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1728 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1250 957l257-250-356-52-66-10-30-60-159-322v963l59 31 318 168-60-355-12-66zm452-262l-363 354 86 500q5 33-6 51.5t-34 18.5q-17 0-40-12l-449-236-449 236q-23 12-40 12-23 0-34-18.5t-6-51.5l86-500-364-354q-32-32-23-59.5t54-34.5l502-73 225-455q20-41 49-41 28 0 49 41l225 455 502 73q45 7 54 34.5t-24 59.5z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1664 596q0-81-21.5-143t-55-98.5-81.5-59.5-94-31-98-8-112 25.5-110.5 64-86.5 72-60 61.5q-18 22-49 22t-49-22q-24-28-60-61.5t-86.5-72-110.5-64-112-25.5-98 8-94 31-81.5 59.5-55 98.5-21.5 143q0 168 187 355l581 560 580-559q188-188 188-356zm128 0q0 221-229 450l-623 600q-18 18-44 18t-44-18l-624-602q-10-8-27.5-26t-55.5-65.5-68-97.5-53.5-121-23.5-138q0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1201 1004l306-297-422-62-189-382-189 382-422 62 306 297-73 421 378-199 377 199zm527-357q0 22-26 48l-363 354 86 500q1 7 1 20 0 50-41 50-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z";
t.default=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.url,n=void 0===t?"#!":t,r=e.text;return r?u.default.createElement("a",{href:n,className:"fit-tag"},r):null}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(78),t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.tags,n=void 0===t?[]:t,r="fit-tag-list";return u.default.createElement("ul",{className:r},n.map(function(e,t){return u.default.createElement("li",{key:t},u.default.createElement(l.default,{text:e.text,url:e.url}))}))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a),i=n(52),l=r(i);n(79),t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(1),s=r(c),f=n(17),p=r(f),d=n(8),h=r(d),v=n(9),y=r(v),m=n(12),b=r(m);n(81);var g=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={attachments:e.attachments||{},value:e.value||""},n}return u(t,e),l(t,[{key:"componentWillReceiveProps",value:function(e){var t=this.state.value,n=e.value||t,r=n===t?t:n;this.setState({attachments:e.attachments||{},value:r})}},{key:"render",value:function(){var e=this,t=this.state.attachments,n=this.props,r=n.attachmentName,o=n.onAttach,a=n.onAbort,u=n.hint,l=n.children,c=Object.keys(t).length>0,f=c?" has-attachments":"";return s.default.createElement("div",{className:"fit-textarea-attachment"+f},s.default.createElement(p.default,i({},this.props,{ref:function(t){return t?e.textarea=t.textarea:null}}),l,s.default.createElement(b.default,u,s.default.createElement(y.default,{name:r,onAttach:o}))),s.default.createElement(h.default,{attachments:t,onAbort:a}))}}]),t}(c.Component);t.default=g},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.toggleName,n=o(e,["toggleName"]);return l.default.createElement("span",{className:"toggle-wrapper"},l.default.createElement("label",{htmlFor:"toggle"+t},l.default.createElement("input",u({type:"checkbox",id:"toggle"+t},n)),l.default.createElement("span",{className:"fake-toggle"})))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(1),l=r(i);n(82),a.propTypes={toggleName:l.default.PropTypes.string.isRequired,checked:l.default.PropTypes.bool,defaultChecked:l.default.PropTypes.bool,onChange:l.default.PropTypes.func},t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(1),c=(r(l),n(89)),s=r(c),f=n(62),p=r(f),d=n(63),h=r(d),v=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e)),r={isActive:n.props.defaultIsActive,inputValue:n.props.defaultInputValue,selectedOption:n.props.defaultSelectedOption,activeOptionIndex:0};return!r.selectedOption||"string"==typeof r.selectedOption&&"number"==typeof r.selectedOption||(r.inputValue=n.props.optionToString(r.selectedOption)),n.controlledOptions=[],n.getOptionProps=n.getOptionProps.bind(n),n.getTextInputProps=n.getTextInputProps.bind(n),n.getMenuButtonProps=n.getMenuButtonProps.bind(n),n.handleInputChange=n.handleInputChange.bind(n),n.handleInputKeyUp=n.handleInputKeyUp.bind(n),n.toggleActive=n.toggleActive.bind(n),n.setActiveFalse=n.setActive.bind(n,!1),n.setActiveTrue=n.setActive.bind(n,!0),n.state=r,n}return u(t,e),i(t,[{key:"componentWillUpdate",value:function(){this.resetControlledOptions()}},{key:"componentDidUpdate",value:function(e,t){(0,h.default)(this.state.selectedOption,t.selectedOption)||this.props.onChange(this.state.selectedOption)}},{key:"resetControlledOptions",value:function(){this.controlledOptions=[]}},{key:"getOptionAtIndex",value:function(e){return this.controlledOptions[e]}},{key:"setActive",value:function(e){this.setState(function(t){return Object.assign({},t,{isActive:e})})}},{key:"toggleActive",value:function(){this.setState(function(e){return Object.assign({},e,{isActive:!e.isActive})})}},{key:"handleInputChange",value:function(e){var t=e.target.value;this.setState(function(e){return Object.assign({},e,{isActive:!0,inputValue:t})})}},{key:"handleInputKeyUp",value:function(e){switch(e.which){case 13:var t=this.getOptionAtIndex(this.state.activeOptionIndex),n="string"==typeof t?t:this.props.optionToString(t);this.setState(function(e){return Object.assign({},e,{isActive:!1,selectedOption:t,inputValue:n})});break;case 38:this.setState(function(e){return Object.assign({},e,{activeOptionIndex:e.activeOptionIndex-1})});break;case 40:this.setState(function(e){return Object.assign({},e,{activeOptionIndex:e.activeOptionIndex+1})})}}},{key:"createOptionMouseEnterHandler",value:function(e){var t=this;return function(){t.setState(function(t){return Object.assign({},t,{activeOptionIndex:e})})}}},{key:"createOptionClickHandler",value:function(e){var t=this;return function(){var n="string"==typeof e?e:t.props.optionToString(e);t.setState(function(t){return Object.assign({},t,{isActive:!1,selectedOption:e,inputValue:n})})}}},{key:"getTextInputProps",value:function(e){var t=this,n={type:"text"},r={onFocus:(0,p.default)(e.onFocus,this.setActiveTrue),onBlur:(0,p.default)(e.onBlur,function(){return setTimeout(t.setActiveFalse,150)}),onChange:(0,p.default)(e.onChange,this.handleInputChange),onKeyUp:(0,p.default)(e.onKeyUp,this.handleInputKeyUp)};return Object.assign({},n,e,r)}},{key:"getOptionProps",value:function(e){var t=e.option,n=this.controlledOptions.length,r={onMouseEnter:(0,p.default)(e.mouseEnter,this.createOptionMouseEnterHandler(n)),onClick:(0,p.default)(e.onClick,this.createOptionClickHandler(t))};if(!t)throw new Error("passing the option property to getOptionProps is required");return delete e.option,this.controlledOptions.push(t),Object.assign({},e,r)}},{key:"getMenuButtonProps",value:function(e){var t={onClick:(0,p.default)(e.onClick,this.toggleActive)};return Object.assign({},e,t)}},{key:"getStateAndHelpers",value:function(){var e=this.state,t=e.isActive,n=e.inputValue,r=e.selectedOption,o=e.activeOptionIndex,a=this.getTextInputProps,u=this.getOptionProps,i=this.getMenuButtonProps;return{isActive:t,inputValue:n,selectedOption:r,getTextInputProps:a,getMenuButtonProps:i,getOptionProps:u,activeOptionIndex:o}}},{key:"render",value:function e(){var t=this.props,e=t.render,n=t.children;if("function"!=typeof e&&"function"!=typeof n)throw new Error("you must provide either a child function or a render property to typeaheadselect");var r=n||e,o=this.getStateAndHelpers();return r(o)}}]),t}(l.Component);v.propTypes={optionToString:s.default.func,onChange:s.default.func,defaultIsActive:s.default.bool,defaultInputValue:s.default.string,defaultSelectedOption:s.default.any},v.defaultProps={optionToString:function(e){return e},onChange:function(e){return e},defaultIsActive:!1,defaultInputValue:""},t.default=v},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.TypeaheadSelect=t.Status=t.TagList=t.Rating=t.SvgIcon=t.ProgressRound=t.ProgressBar=t.Input=t.ToggleButton=t.TextareaAttachment=t.TextaraAttachment=t.Textarea=t.Breadcrumbs=t.PageAlert=t.Pagination=t.EasyTable=t.SimpleUploader=t.SimpleError=t.Select=t.Option=t.ErrorMessage=t.Radio=t.Checkbox=t.Collapsable=t.Currency=t.Cta=t.ButtonAttachment=t.Button=t.Avatar=t.AttachmentList=void 0;var o=n(1),a=(r(o),n(8)),u=r(a),i=n(27),l=r(i),c=n(29),s=r(c),f=n(9),p=r(f),d=n(33),h=r(d),v=n(34),y=r(v),m=n(54),b=r(m),g=n(15),_=r(g),O=n(55),P=r(O),E=n(32),j=r(E),x=n(31),w=r(x),M=n(14),k=r(M),C=n(37),T=r(C),N=n(40),A=r(N),S=n(39),q=r(S),I=n(10),R=r(I),D=n(41),F=r(D),B=n(36),z=r(B),Y=n(28),U=r(Y),V=n(17),W=r(V),L=n(13),G=r(L),K=n(61),H=n(35),$=r(H),J=n(16),Q=r(J),X=n(38),Z=r(X),ee=n(53),te=r(ee),ne=n(42),re=r(ne),oe=n(56),ae=r(oe),ue=b.default;t.AttachmentList=u.default,t.Avatar=l.default,t.Button=s.default,t.ButtonAttachment=p.default,t.Cta=h.default,t.Currency=y.default,t.Collapsable=j.default,t.Checkbox=w.default,t.Radio=T.default,t.ErrorMessage=_.default,t.Option=A.default,t.Select=q.default,t.SimpleError=R.default,t.SimpleUploader=F.default,t.EasyTable=$.default,t.Pagination=k.default,t.PageAlert=z.default,t.Breadcrumbs=U.default,t.Textarea=W.default,t.TextaraAttachment=ue,t.TextareaAttachment=b.default,t.ToggleButton=P.default,t.Input=G.default,t.ProgressBar=K.ProgressBar,t.ProgressRound=K.ProgressRound,t.SvgIcon=Q.default,t.Rating=Z.default,t.TagList=te.default,t.Status=re.default,t.TypeaheadSelect=ae.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.value,n=e.max,r=void 0===n?1:n,o=t/r*100;return u.default.createElement("div",{className:"fit-progress-bar"},u.default.createElement("span",{className:"fill",style:{width:o+"%"}}))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(83),o.propTypes={value:u.default.PropTypes.number,max:u.default.PropTypes.number},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(58),a=r(o);t.default=a.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.progress,n=void 0===t?0:t,r=204,o={strokeDasharray:r,strokeDashoffset:r},a=function(e){var t=r*e/100;return Object.assign({},o,{strokeDashoffset:r-t})},l=a(n);return u.default.createElement("div",{className:"fit-round-progress"},u.default.createElement("div",{className:"back-layer"}),u.default.createElement("svg",{viewBox:"-1 -1 71 71"},u.default.createElement("path",{d:i,style:l})))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(84);var i="m35,2.5c17.955803,0 32.5,14.544199 32.5,32.5c0,17.955803 -14.544197,32.5 -32.5,32.5c-17.955803,0 -32.5,-14.544197 -32.5,-32.5c0,-17.955801 14.544197,-32.5 32.5,-32.5z";o.propTypes={progress:u.default.PropTypes.number},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.ProgressBar=t.ProgressRound=void 0;var o=n(18),a=r(o),u=n(59),i=r(u);t.ProgressRound=a.default,t.ProgressBar=i.default},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];return function(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];return t.forEach(function(e){return e&&e.apply(void 0,n)})}}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=function(e,t){if(e===t)return!0;if("undefined"==typeof e||"undefined"==typeof t)return e===t;if(null===e||null===t||"object"!==("undefined"==typeof e?"undefined":n(e))&&"object"!==("undefined"==typeof t?"undefined":n(t)))return e!==e&&t!==t;var r=Array.isArray(e),o=Array.isArray(t);if(r!==o)return!1;if(r&&o){if(e.length!==t.length)return!1;for(var a=0;a<e.length;a++)if(e[a]!==t[a])return!1}var u=Object.keys(e),i=Object.keys(t);if(u.length!==i.length)return!1;for(var l=0;l<u.length;l++)if(u[l]!==i[l]||e[u[l]]!==t[i[l]])return!1;return!0}},function(e,t,n){"use strict";function r(e){return e}function o(e,t,n){function o(e,t){var n=b.hasOwnProperty(t)?b[t]:null;P.hasOwnProperty(t)&&l("OVERRIDE_BASE"===n,"ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.",t),e&&l("DEFINE_MANY"===n||"DEFINE_MANY_MERGED"===n,"ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",t)}function a(e,n){if(n){l("function"!=typeof n,"ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object."),l(!t(n),"ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object.");var r=e.prototype,a=r.__reactAutoBindPairs;n.hasOwnProperty(c)&&g.mixins(e,n.mixins);for(var u in n)if(n.hasOwnProperty(u)&&u!==c){var i=n[u],s=r.hasOwnProperty(u);if(o(s,u),g.hasOwnProperty(u))g[u](e,i);else{var f=b.hasOwnProperty(u),h="function"==typeof i,v=h&&!f&&!s&&n.autobind!==!1;if(v)a.push(u,i),r[u]=i;else if(s){var y=b[u];l(f&&("DEFINE_MANY_MERGED"===y||"DEFINE_MANY"===y),"ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.",y,u),"DEFINE_MANY_MERGED"===y?r[u]=p(r[u],i):"DEFINE_MANY"===y&&(r[u]=d(r[u],i))}else r[u]=i}}}else;}function s(e,t){if(t)for(var n in t){var r=t[n];if(t.hasOwnProperty(n)){var o=n in g;l(!o,'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.',n);var a=n in e;l(!a,"ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",n),e[n]=r}}}function f(e,t){l(e&&t&&"object"==typeof e&&"object"==typeof t,"mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.");for(var n in t)t.hasOwnProperty(n)&&(l(void 0===e[n],"mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.",n),e[n]=t[n]);return e}function p(e,t){return function(){var n=e.apply(this,arguments),r=t.apply(this,arguments);if(null==n)return r;if(null==r)return n;var o={};return f(o,n),f(o,r),o}}function d(e,t){return function(){e.apply(this,arguments),t.apply(this,arguments)}}function h(e,t){var n=t.bind(e);return n}function v(e){for(var t=e.__reactAutoBindPairs,n=0;n<t.length;n+=2){var r=t[n],o=t[n+1];e[r]=h(e,o)}}function y(e){var t=r(function(e,r,o){this.__reactAutoBindPairs.length&&v(this),this.props=e,this.context=r,this.refs=i,this.updater=o||n,this.state=null;var a=this.getInitialState?this.getInitialState():null;l("object"==typeof a&&!Array.isArray(a),"%s.getInitialState(): must return an object or null",t.displayName||"ReactCompositeComponent"),this.state=a});t.prototype=new E,t.prototype.constructor=t,t.prototype.__reactAutoBindPairs=[],m.forEach(a.bind(null,t)),a(t,_),a(t,e),a(t,O),t.getDefaultProps&&(t.defaultProps=t.getDefaultProps()),l(t.prototype.render,"createClass(...): Class specification must implement a `render` method.");for(var o in b)t.prototype[o]||(t.prototype[o]=null);return t}var m=[],b={mixins:"DEFINE_MANY",statics:"DEFINE_MANY",propTypes:"DEFINE_MANY",contextTypes:"DEFINE_MANY",childContextTypes:"DEFINE_MANY",getDefaultProps:"DEFINE_MANY_MERGED",getInitialState:"DEFINE_MANY_MERGED",getChildContext:"DEFINE_MANY_MERGED",render:"DEFINE_ONCE",componentWillMount:"DEFINE_MANY",componentDidMount:"DEFINE_MANY",componentWillReceiveProps:"DEFINE_MANY",shouldComponentUpdate:"DEFINE_ONCE",componentWillUpdate:"DEFINE_MANY",componentDidUpdate:"DEFINE_MANY",componentWillUnmount:"DEFINE_MANY",updateComponent:"OVERRIDE_BASE"},g={displayName:function(e,t){e.displayName=t},mixins:function(e,t){if(t)for(var n=0;n<t.length;n++)a(e,t[n])},childContextTypes:function(e,t){e.childContextTypes=u({},e.childContextTypes,t)},contextTypes:function(e,t){e.contextTypes=u({},e.contextTypes,t)},getDefaultProps:function(e,t){e.getDefaultProps?e.getDefaultProps=p(e.getDefaultProps,t):e.getDefaultProps=t},propTypes:function(e,t){e.propTypes=u({},e.propTypes,t)},statics:function(e,t){s(e,t)},autobind:function(){}},_={componentDidMount:function(){this.__isMounted=!0}},O={componentWillUnmount:function(){this.__isMounted=!1}},P={replaceState:function(e,t){this.updater.enqueueReplaceState(this,e,t)},isMounted:function(){return!!this.__isMounted}},E=function(){};return u(E.prototype,e.prototype,P),y}var a,u=n(6),i=n(19),l=n(2),c="mixins";a={},e.exports=o},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";function r(e,t,n,r,o){}e.exports=r},function(e,t,n){"use strict";var r=n(88);e.exports=function(e){var t=!1;return r(e,t)}},function(e,t,n){"use strict";var r=n(4),o=n(2),a=n(20);e.exports=function(){function e(e,t,n,r,u,i){i!==a&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t,n){"use strict";var r=n(4),o=n(2),a=n(5),u=n(20),i=n(85);e.exports=function(e,t){function n(e){var t=e&&(M&&e[M]||e[k]);if("function"==typeof t)return t}function l(e,t){return e===t?0!==e||1/e===1/t:e!==e&&t!==t}function c(e){this.message=e,this.stack=""}function s(e){function n(n,r,a,i,l,s,f){if(i=i||C,s=s||a,f!==u)if(t)o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else;return null==r[a]?n?new c(null===r[a]?"The "+l+" `"+s+"` is marked as required "+("in `"+i+"`, but its value is `null`."):"The "+l+" `"+s+"` is marked as required in "+("`"+i+"`, but its value is `undefined`.")):null:e(r,a,i,l,s)}var r=n.bind(null,!1);return r.isRequired=n.bind(null,!0),r}function f(e){function t(t,n,r,o,a,u){var i=t[n],l=E(i);if(l!==e){var s=j(i);return new c("Invalid "+o+" `"+a+"` of type "+("`"+s+"` supplied to `"+r+"`, expected ")+("`"+e+"`."))}return null}return s(t)}function p(){return s(r.thatReturnsNull)}function d(e){function t(t,n,r,o,a){if("function"!=typeof e)return new c("Property `"+a+"` of component `"+r+"` has invalid PropType notation inside arrayOf.");var i=t[n];if(!Array.isArray(i)){var l=E(i);return new c("Invalid "+o+" `"+a+"` of type "+("`"+l+"` supplied to `"+r+"`, expected an array."))}for(var s=0;s<i.length;s++){var f=e(i,s,r,o,a+"["+s+"]",u);if(f instanceof Error)return f}return null}return s(t)}function h(){function t(t,n,r,o,a){var u=t[n];if(!e(u)){var i=E(u);return new c("Invalid "+o+" `"+a+"` of type "+("`"+i+"` supplied to `"+r+"`, expected a single ReactElement."))}return null}return s(t)}function v(e){function t(t,n,r,o,a){if(!(t[n]instanceof e)){var u=e.name||C,i=w(t[n]);return new c("Invalid "+o+" `"+a+"` of type "+("`"+i+"` supplied to `"+r+"`, expected ")+("instance of `"+u+"`."))}return null}return s(t)}function y(e){function t(t,n,r,o,a){for(var u=t[n],i=0;i<e.length;i++)if(l(u,e[i]))return null;var s=JSON.stringify(e);return new c("Invalid "+o+" `"+a+"` of value `"+u+"` "+("supplied to `"+r+"`, expected one of "+s+"."))}return Array.isArray(e)?s(t):r.thatReturnsNull}function m(e){function t(t,n,r,o,a){if("function"!=typeof e)return new c("Property `"+a+"` of component `"+r+"` has invalid PropType notation inside objectOf.");var i=t[n],l=E(i);if("object"!==l)return new c("Invalid "+o+" `"+a+"` of type "+("`"+l+"` supplied to `"+r+"`, expected an object."));for(var s in i)if(i.hasOwnProperty(s)){var f=e(i,s,r,o,a+"."+s,u);if(f instanceof Error)return f}return null}return s(t)}function b(e){function t(t,n,r,o,a){for(var i=0;i<e.length;i++){var l=e[i];if(null==l(t,n,r,o,a,u))return null}return new c("Invalid "+o+" `"+a+"` supplied to "+("`"+r+"`."))}if(!Array.isArray(e))return r.thatReturnsNull;for(var n=0;n<e.length;n++){var o=e[n];if("function"!=typeof o)return a(!1,"Invalid argument supplid to oneOfType. Expected an array of check functions, but received %s at index %s.",x(o),n),r.thatReturnsNull}return s(t)}function g(){function e(e,t,n,r,o){return O(e[t])?null:new c("Invalid "+r+" `"+o+"` supplied to "+("`"+n+"`, expected a ReactNode."))}return s(e)}function _(e){function t(t,n,r,o,a){var i=t[n],l=E(i);if("object"!==l)return new c("Invalid "+o+" `"+a+"` of type `"+l+"` "+("supplied to `"+r+"`, expected `object`."));for(var s in e){var f=e[s];if(f){var p=f(i,s,r,o,a+"."+s,u);if(p)return p}}return null}return s(t)}function O(t){switch(typeof t){case"number":case"string":case"undefined":return!0;case"boolean":return!t;case"object":if(Array.isArray(t))return t.every(O);if(null===t||e(t))return!0;var r=n(t);if(!r)return!1;var o,a=r.call(t);if(r!==t.entries){for(;!(o=a.next()).done;)if(!O(o.value))return!1}else for(;!(o=a.next()).done;){var u=o.value;if(u&&!O(u[1]))return!1}return!0;default:return!1}}function P(e,t){return"symbol"===e||("Symbol"===t["@@toStringTag"]||"function"==typeof Symbol&&t instanceof Symbol)}function E(e){var t=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":P(t,e)?"symbol":t}function j(e){if("undefined"==typeof e||null===e)return""+e;var t=E(e);if("object"===t){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return t}function x(e){var t=j(e);switch(t){case"array":case"object":return"an "+t;case"boolean":case"date":case"regexp":return"a "+t;default:return t}}function w(e){return e.constructor&&e.constructor.name?e.constructor.name:C}var M="function"==typeof Symbol&&Symbol.iterator,k="@@iterator",C="<<anonymous>>",T={array:f("array"),bool:f("boolean"),func:f("function"),number:f("number"),object:f("object"),string:f("string"),symbol:f("symbol"),any:p(),arrayOf:d,element:h(),instanceOf:v,node:g(),objectOf:m,oneOf:y,oneOfType:b,shape:_};return c.prototype=Error.prototype,T.checkPropTypes=i,T.PropTypes=T,T}},function(e,t,n){e.exports=n(87)()},function(e,t){"use strict";function n(e){var t=/[=:]/g,n={"=":"=0",":":"=2"},r=(""+e).replace(t,function(e){return n[e]});return"$"+r}function r(e){var t=/(=0|=2)/g,n={"=0":"=","=2":":"},r="."===e[0]&&"$"===e[1]?e.substring(2):e.substring(1);return(""+r).replace(t,function(e){return n[e]})}var o={escape:n,unescape:r};e.exports=o},function(e,t,n){"use strict";var r=n(7),o=(n(2),function(e){var t=this;if(t.instancePool.length){var n=t.instancePool.pop();return t.call(n,e),n}return new t(e)}),a=function(e,t){var n=this;if(n.instancePool.length){var r=n.instancePool.pop();return n.call(r,e,t),r}return new n(e,t)},u=function(e,t,n){var r=this;if(r.instancePool.length){var o=r.instancePool.pop();return r.call(o,e,t,n),o}return new r(e,t,n)},i=function(e,t,n,r){var o=this;if(o.instancePool.length){var a=o.instancePool.pop();return o.call(a,e,t,n,r),a}return new o(e,t,n,r)},l=function(e){var t=this;e instanceof t?void 0:r("25"),e.destructor(),t.instancePool.length<t.poolSize&&t.instancePool.push(e)},c=10,s=o,f=function(e,t){var n=e;return n.instancePool=[],n.getPooled=t||s,n.poolSize||(n.poolSize=c),n.release=l,n},p={addPoolingTo:f,oneArgumentPooler:o,twoArgumentPooler:a,threeArgumentPooler:u,fourArgumentPooler:i};e.exports=p},function(e,t,n){"use strict";var r=n(6),o=n(21),a=n(93),u=n(94),i=n(3),l=n(95),c=n(96),s=n(97),f=n(100),p=i.createElement,d=i.createFactory,h=i.cloneElement,v=r,y=function(e){return e},m={Children:{map:a.map,forEach:a.forEach,count:a.count,toArray:a.toArray,only:f},Component:o.Component,PureComponent:o.PureComponent,createElement:p,cloneElement:h,isValidElement:i.isValidElement,PropTypes:l,createClass:s,createFactory:d,createMixin:y,DOM:u,version:c,__spread:v};e.exports=m},function(e,t,n){"use strict";function r(e){return(""+e).replace(_,"$&/")}function o(e,t){this.func=e,this.context=t,this.count=0}function a(e,t,n){var r=e.func,o=e.context;r.call(o,t,e.count++)}function u(e,t,n){if(null==e)return e;var r=o.getPooled(t,n);m(e,a,r),o.release(r)}function i(e,t,n,r){this.result=e,this.keyPrefix=t,this.func=n,this.context=r,this.count=0}function l(e,t,n){var o=e.result,a=e.keyPrefix,u=e.func,i=e.context,l=u.call(i,t,e.count++);Array.isArray(l)?c(l,o,n,y.thatReturnsArgument):null!=l&&(v.isValidElement(l)&&(l=v.cloneAndReplaceKey(l,a+(!l.key||t&&t.key===l.key?"":r(l.key)+"/")+n)),o.push(l))}function c(e,t,n,o,a){var u="";null!=n&&(u=r(n)+"/");var c=i.getPooled(t,u,o,a);m(e,l,c),i.release(c)}function s(e,t,n){if(null==e)return e;var r=[];return c(e,r,null,t,n),r}function f(e,t,n){return null}function p(e,t){return m(e,f,null)}function d(e){var t=[];return c(e,t,null,y.thatReturnsArgument),t}var h=n(91),v=n(3),y=n(4),m=n(101),b=h.twoArgumentPooler,g=h.fourArgumentPooler,_=/\/+/g;o.prototype.destructor=function(){this.func=null,this.context=null,this.count=0},h.addPoolingTo(o,b),i.prototype.destructor=function(){this.result=null,this.keyPrefix=null,this.func=null,this.context=null,this.count=0},h.addPoolingTo(i,g);var O={forEach:u,map:s,mapIntoWithKeyPrefixInternal:c,count:p,toArray:d};e.exports=O},function(e,t,n){"use strict";var r=n(3),o=r.createFactory,a={a:o("a"),abbr:o("abbr"),address:o("address"),area:o("area"),article:o("article"),aside:o("aside"),audio:o("audio"),b:o("b"),base:o("base"),bdi:o("bdi"),bdo:o("bdo"),big:o("big"),blockquote:o("blockquote"),body:o("body"),br:o("br"),button:o("button"),canvas:o("canvas"),caption:o("caption"),cite:o("cite"),code:o("code"),col:o("col"),colgroup:o("colgroup"),data:o("data"),datalist:o("datalist"),dd:o("dd"),del:o("del"),details:o("details"),dfn:o("dfn"),dialog:o("dialog"),div:o("div"),dl:o("dl"),dt:o("dt"),em:o("em"),embed:o("embed"),fieldset:o("fieldset"),figcaption:o("figcaption"),figure:o("figure"),footer:o("footer"),form:o("form"),h1:o("h1"),h2:o("h2"),h3:o("h3"),h4:o("h4"),h5:o("h5"),h6:o("h6"),head:o("head"),header:o("header"),hgroup:o("hgroup"),hr:o("hr"),html:o("html"),i:o("i"),iframe:o("iframe"),img:o("img"),input:o("input"),ins:o("ins"),kbd:o("kbd"),keygen:o("keygen"),label:o("label"),legend:o("legend"),li:o("li"),link:o("link"),main:o("main"),map:o("map"),mark:o("mark"),menu:o("menu"),menuitem:o("menuitem"),meta:o("meta"),meter:o("meter"),nav:o("nav"),noscript:o("noscript"),object:o("object"),ol:o("ol"),optgroup:o("optgroup"),option:o("option"),output:o("output"),p:o("p"),param:o("param"),picture:o("picture"),pre:o("pre"),progress:o("progress"),q:o("q"),rp:o("rp"),rt:o("rt"),ruby:o("ruby"),s:o("s"),samp:o("samp"),script:o("script"),section:o("section"),select:o("select"),small:o("small"),source:o("source"),span:o("span"),strong:o("strong"),style:o("style"),sub:o("sub"),summary:o("summary"),sup:o("sup"),table:o("table"),tbody:o("tbody"),td:o("td"),textarea:o("textarea"),tfoot:o("tfoot"),th:o("th"),thead:o("thead"),time:o("time"),title:o("title"),tr:o("tr"),track:o("track"),u:o("u"),ul:o("ul"),var:o("var"),video:o("video"),wbr:o("wbr"),circle:o("circle"),clipPath:o("clipPath"),defs:o("defs"),ellipse:o("ellipse"),g:o("g"),image:o("image"),line:o("line"),linearGradient:o("linearGradient"),mask:o("mask"),path:o("path"),pattern:o("pattern"),polygon:o("polygon"),polyline:o("polyline"),radialGradient:o("radialGradient"),rect:o("rect"),stop:o("stop"),svg:o("svg"),text:o("text"),tspan:o("tspan")};e.exports=a},function(e,t,n){"use strict";var r=n(3),o=r.isValidElement,a=n(86);e.exports=a(o)},function(e,t){"use strict";e.exports="15.6.1"},function(e,t,n){"use strict";var r=n(21),o=r.Component,a=n(3),u=a.isValidElement,i=n(24),l=n(64);e.exports=l(o,u,i)},function(e,t){"use strict";function n(e){var t=e&&(r&&e[r]||e[o]);if("function"==typeof t)return t}var r="function"==typeof Symbol&&Symbol.iterator,o="@@iterator";e.exports=n},function(e,t,n){"use strict";var r=function(){};e.exports=r},function(e,t,n){"use strict";function r(e){return a.isValidElement(e)?void 0:o("143"),e}var o=n(7),a=n(3);n(2);e.exports=r},function(e,t,n){"use strict";function r(e,t){return e&&"object"==typeof e&&null!=e.key?c.escape(e.key):t.toString(36)}function o(e,t,n,a){var p=typeof e;if("undefined"!==p&&"boolean"!==p||(e=null),null===e||"string"===p||"number"===p||"object"===p&&e.$$typeof===i)return n(a,e,""===t?s+r(e,0):t),1;var d,h,v=0,y=""===t?s:t+f;if(Array.isArray(e))for(var m=0;m<e.length;m++)d=e[m],h=y+r(d,m),v+=o(d,h,n,a);else{var b=l(e);if(b){var g,_=b.call(e);if(b!==e.entries)for(var O=0;!(g=_.next()).done;)d=g.value,h=y+r(d,O++),v+=o(d,h,n,a);else for(;!(g=_.next()).done;){var P=g.value;P&&(d=P[1],h=y+c.escape(P[0])+f+r(d,0),v+=o(d,h,n,a))}}else if("object"===p){var E="",j=String(e);u("31","[object Object]"===j?"object with keys {"+Object.keys(e).join(", ")+"}":j,E)}}return v}function a(e,t,n){return null==e?0:o(e,"",t,n)}var u=n(7),i=(n(22),n(23)),l=n(98),c=(n(2),n(90)),s=(n(5),"."),f=":";e.exports=a}])});

/***/ }),

/***/ "vUMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React","var":"React"}
var external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__ = __webpack_require__("Jmof");
var external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__);

// EXTERNAL MODULE: external {"commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types","root":"PropTypes","var":"PropTypes"}
var external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes__ = __webpack_require__("T9WB");
var external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes__);

// EXTERNAL MODULE: ./src/translations.en.json
var translations_en = __webpack_require__("eIBB");
var translations_en_default = /*#__PURE__*/__webpack_require__.n(translations_en);

// CONCATENATED MODULE: ./src/helper.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var submitVacation = function submitVacation(data) {
    var url = '/users/' + data.userId + '/vacations';

    return gofor(url, {
        method: 'POST',
        body: JSON.stringify(data)
    }).then(function (response) {
        return response.json();
    });
};

var helper_notify = function notify(gigId) {
    var gig = typeof gigId !== 'undefined' ? gigId : Fiverr.models.ps.gig_id;
    var url = '/vacations/' + gig + '/waiting_customers';

    return gofor(url, {
        method: 'POST'
    }).then(function (response) {
        if (!response.ok) {
            throw new Error('');
        }
        return response.json();
    }).catch(function (err) {
        throw err;
    });
};

var updateNotify = function updateNotify(gigId) {
    var url = '/vacations/' + gigId + '/is_buyer_waiting_for_gig';

    return gofor(url, {
        method: 'GET'
    }).then(function (response) {
        if (!response.ok) {
            throw new Error('updateNotify');
        }
        return response.json();
    }).catch(function (err) {
        throw err;
    });
};

/* eslint-disable */
var DATE_REGEX = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
var DATEPICKER_REGEX = /^\d{4}-\d{2}-\d{2}$/;
/* eslint-enable */

var dateIsValid = function dateIsValid(value) {

    if (typeof value !== 'string') {
        return false;
    }

    if (!value.match(DATE_REGEX) && !value.match(DATEPICKER_REGEX)) {
        return false;
    } // Invalid format

    var d = new Date(value);

    var dTime = d.getTime();
    if (!dTime && dTime !== 0) {
        return false; // Invalid date
    }

    if (dTime < new Date().getTime()) {
        return false; // Date in future
    }

    return true;
};

var turnVacationOff = function turnVacationOff(username) {
    var url = '/users/' + username + '/vacations';

    return gofor(url, {
        method: 'DELETE'
    });
};

var getDateString = function getDateString(dateTimestamp) {

    var dateObj = new Date(dateTimestamp * 1000);
    var dateString = dateObj.toLocaleString('en-us', { day: 'numeric', month: 'short', year: 'numeric' });

    return dateString;
};

/* Checks if the date exist and not in the past*/
var isValidDate = function isValidDate(dateVal) {
    var date = new Date(dateVal.yyyy, dateVal.mm - 1, dateVal.dd),
        convertedDate = (date.getFullYear() + (date.getMonth() + 1) + date.getDate()).toString(),
        givenDate = (dateVal.yyyy + dateVal.mm + dateVal.dd).toString(),
        today = new Date().setHours(0, 0, 0, 0);
    var sendDate = dateVal.mm + '/' + dateVal.dd + '/' + dateVal.yyyy;

    sendDate = Date.parse(sendDate);

    return givenDate === convertedDate && sendDate >= today;
};

var reportEvent = function reportEvent(type, data) {
    var other = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;


    var groupStr = other ? other : 'out_of_office',
        typeStr = '' + (!other ? 'out_of_office.' : '') + type;

    var eventData = {
        type: typeStr,
        group: groupStr
    };

    eventData = Object.assign({}, eventData, _extends({}, data));

    Fiverr.sendClientEvents(eventData);
};
// CONCATENATED MODULE: ./src/TurnOff/TurnOff.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var TurnOff_TurnOff = function (_Component) {
    _inherits(TurnOff, _Component);

    function TurnOff(props) {
        _classCallCheck(this, TurnOff);

        var _this = _possibleConstructorReturn(this, (TurnOff.__proto__ || Object.getPrototypeOf(TurnOff)).call(this, props));

        _this.state = {
            isHidden: false
        };

        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(TurnOff, [{
        key: 'onClick',
        value: function onClick(e) {
            e && e.preventDefault();

            reportEvent('click_off', {
                'current_page_type': 'gigs_page',
                'seller': {
                    'id': this.props.userId
                }
            });

            this.props.turnOff();
        }
    }, {
        key: 'render',
        value: function render() {
            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'a',
                { href: '#!', className: 'turn-off-link', onClick: this.onClick },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('i', { className: 'fa fa-briefcase', 'aria-hidden': 'true' }),
                ' Turn Off'
            );
        }
    }]);

    return TurnOff;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["Component"]);

TurnOff_TurnOff.propTypes = {
    turnOff: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func.isRequired,
    userId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number.isRequired
};

TurnOff_TurnOff.defaultProps = {
    turnOff: function turnOff() {
        return null;
    },
    userId: 0
};

/* harmony default export */ var src_TurnOff_TurnOff = (TurnOff_TurnOff);
// CONCATENATED MODULE: ./src/GigBanner/Seller.js



var Seller_Seller = function Seller(_ref) {
    var endDate = _ref.endDate,
        openPopup = _ref.openPopup,
        turnOff = _ref.turnOff,
        userId = _ref.userId,
        isMobile = _ref.isMobile;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        { className: 'content seller-view' },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'h3',
            { className: 'title' },
            i18n.t('out_of_office.banner.seller.you_are_out'),
            !!endDate && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'span',
                null,
                i18n.t('out_of_office.banner.seller.until', { endDate: endDate })
            )
        ),
        !isMobile && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'p',
            { className: 'notice' },
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'a',
                { className: 'popup-link', onClick: function onClick(e) {
                        return openPopup(e, 'gigs_page');
                    } },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('i', { className: 'fa fa-pencil', 'aria-hidden': 'true' }),
                ' ',
                i18n.t('out_of_office.general.edit')
            ),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(src_TurnOff_TurnOff, { turnOff: turnOff, userId: userId })
        )
    );
};

/* harmony default export */ var GigBanner_Seller = (Seller_Seller);
// CONCATENATED MODULE: ./src/GigBanner/Buyer.js


var Buyer_Buyer = function Buyer(_ref) {
    var username = _ref.username,
        endDate = _ref.endDate,
        allowContact = _ref.allowContact,
        notify = _ref.notify,
        showNotify = _ref.showNotify,
        notifyBuyer = _ref.notifyBuyer,
        clickContact = _ref.clickContact;

    var showNotifyMessage = !allowContact && showNotify;

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        "div",
        { className: "content buyer-view" },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "h3",
            { className: "title" },
            i18n.t('out_of_office.banner.buyer.is_out', { username: username }),
            !!endDate && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                "span",
                null,
                i18n.t('out_of_office.banner.buyer.until', { endDate: endDate })
            )
        ),
        allowContact && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "p",
            { className: "notice" },
            i18n.t('out_of_office.banner.buyer.meantime'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                "a",
                { href: "/conversations/" + username, className: "js-contact-me", onClick: clickContact },
                i18n.t('out_of_office.banner.buyer.contact')
            ),
            " ",
            username
        ),
        showNotifyMessage && notify && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "p",
            { className: "notice" },
            i18n.t('out_of_office.banner.buyer.notify', { username: username })
        ),
        showNotifyMessage && !notify && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "p",
            { className: "notice" },
            i18n.t('out_of_office.banner.buyer.notify_me_1'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                "a",
                { onClick: notifyBuyer },
                "here"
            ),
            i18n.t('out_of_office.banner.buyer.notify_me_2', { username: username })
        )
    );
};

/* harmony default export */ var GigBanner_Buyer = (Buyer_Buyer);
// CONCATENATED MODULE: ./src/GigBanner/GigBanner.js
var GigBanner__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function GigBanner__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function GigBanner__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function GigBanner__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var GigBanner_GigBanner = function (_Component) {
    GigBanner__inherits(GigBanner, _Component);

    function GigBanner(props) {
        GigBanner__classCallCheck(this, GigBanner);

        var _this = GigBanner__possibleConstructorReturn(this, (GigBanner.__proto__ || Object.getPrototypeOf(GigBanner)).call(this, props));

        _this.state = {
            notify: false,
            showNotify: false
        };

        _this.notifyBuyer = _this.notifyBuyer.bind(_this);
        _this.clickContact = _this.clickContact.bind(_this);
        return _this;
    }

    GigBanner__createClass(GigBanner, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            updateNotify(this.props.gigId).then(function (data) {
                _this2.setState({
                    notify: data.guest || data.is_buyer_waiting_for_gig,
                    showNotify: !data.guest
                });
            });
        }
    }, {
        key: 'notifyBuyer',
        value: function notifyBuyer() {
            var _this3 = this;

            helper_notify(this.props.gigId).then(function (data) {
                if (data.status === 'success') {
                    reportEvent('notify_me.by_buyer_request', {
                        'gig': {
                            'id': _this3.props.gigId || Fiverr.models.ps.gig_id
                        }
                    });

                    _this3.setState({
                        notify: true
                    });
                } else {
                    throw '';
                }
            });
        }
    }, {
        key: 'clickContact',
        value: function clickContact() {
            reportEvent('contact_me.click', {
                'current_page_type': 'gigs_page',
                'gig': {
                    'id': this.props.gigId || Fiverr.models.ps.gig_id
                }
            }, 'conversation');
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                notify = _state.notify,
                showNotify = _state.showNotify;
            var _props = this.props,
                isOnVacation = _props.isOnVacation,
                dateVal = _props.dateVal,
                allowContact = _props.allowContact,
                isPageOwner = _props.isPageOwner,
                username = _props.username,
                openPopup = _props.openPopup,
                turnOff = _props.turnOff,
                userId = _props.userId,
                profileImageUrl = _props.profileImageUrl,
                isMobile = _props.isMobile;


            if (!isOnVacation) {
                return null;
            }

            var hideBannerClass = !isOnVacation ? ' hidden' : '',
                endDate = dateVal ? getDateString(dateVal) : dateVal;

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'banner gig-page cf' + hideBannerClass },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'img-wrapper' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'span',
                        { className: 'user-pict-60' },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('img', { src: profileImageUrl, alt: username })
                    ),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('span', { className: 'user-ooo-indicator' })
                ),
                isPageOwner ? external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(GigBanner_Seller, { endDate: endDate,
                    openPopup: openPopup,
                    turnOff: turnOff,
                    userId: userId,
                    isMobile: isMobile }) : external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(GigBanner_Buyer, { endDate: endDate,
                    allowContact: allowContact,
                    notify: notify,
                    showNotify: showNotify,
                    notifyBuyer: this.notifyBuyer,
                    username: username,
                    clickContact: this.clickContact })
            );
        }
    }]);

    return GigBanner;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["Component"]);

GigBanner_GigBanner.propTypes = {
    isPageOwner: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    isOnVacation: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    profileImageUrl: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    username: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    allowContact: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool
};

GigBanner_GigBanner.defaultProps = {
    isPageOwner: false,
    isOnVacation: false,
    profileImageUrl: '',
    username: '',
    allowContact: false
};

/* harmony default export */ var src_GigBanner_GigBanner = (GigBanner_GigBanner);
// EXTERNAL MODULE: ./src/VacationPopup/VacationPopup.scss
var VacationPopup_VacationPopup = __webpack_require__("fCd0");
var VacationPopup_default = /*#__PURE__*/__webpack_require__.n(VacationPopup_VacationPopup);

// EXTERNAL MODULE: ./node_modules/@fiverr/fit/dist/index.js
var dist = __webpack_require__("tBbN");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./src/VacationPopup/VacationForm/VacationForm.scss
var VacationForm_VacationForm = __webpack_require__("EODv");
var VacationForm_default = /*#__PURE__*/__webpack_require__.n(VacationForm_VacationForm);

// CONCATENATED MODULE: ./src/VacationPopup/VacationForm/VacationForm.js
var VacationForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function VacationForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function VacationForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function VacationForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







var WHY_VACATION = ['on_vacation', 'overbooked', 'other'];
var DAYS = [].concat(_toConsumableArray(Array(31).keys())).map(function (v) {
    return 1 + v;
}); // days range 1..31
var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var YEARS = [new Date().getFullYear(), new Date().getFullYear() + 1];

var MAX_TEXT_LENGTH = 120;

var VacationForm_VacationForm_VacationForm = function (_Component) {
    VacationForm__inherits(VacationForm, _Component);

    function VacationForm(props) {
        VacationForm__classCallCheck(this, VacationForm);

        var _this = VacationForm__possibleConstructorReturn(this, (VacationForm.__proto__ || Object.getPrototypeOf(VacationForm)).call(this, props));

        var returnDate = typeof props.dateVal !== 'undefined' ? new Date(props.dateVal * 1000) : new Date(),
            currDate = new Date().setHours(0, 0, 0, 0) / 1000;

        _this.dateToObj = _this.dateToObj.bind(_this);
        _this.changeVacationReason = _this.changeVacationReason.bind(_this);
        _this.changeBuyerMessage = _this.changeBuyerMessage.bind(_this);
        _this.changeAllowContact = _this.changeAllowContact.bind(_this);
        _this.submit = _this.submit.bind(_this);

        _this.state = {
            endDate: props.dateVal || currDate,
            returnDate: _this.dateToObj(returnDate) || '',
            disableSubmit: !returnDate,
            whyVacation: props.whyVacation || '',
            buyerMessage: props.buyerMessage || '',
            allowContact: props.allowContact,
            errorMessage: ''
        };

        return _this;
    }

    VacationForm__createClass(VacationForm, [{
        key: 'dateToObj',
        value: function dateToObj(date) {
            var dd = date.getDate(),
                mm = date.getMonth() + 1,
                yyyy = date.getFullYear();

            return {
                dd: dd,
                mm: mm,
                yyyy: yyyy
            };
        }
    }, {
        key: 'changeVacationReason',
        value: function changeVacationReason(value) {
            this.setState({
                whyVacation: value,
                buyerMessage: value.length ? i18n.t('out_of_office.popup.leave_message.' + value) : ''
            });
        }
    }, {
        key: 'changeAllowContact',
        value: function changeAllowContact() {
            this.setState({ allowContact: !this.state.allowContact });
        }
    }, {
        key: 'changeBuyerMessage',
        value: function changeBuyerMessage(value) {
            if (value.length < MAX_TEXT_LENGTH) {
                this.setState({
                    buyerMessage: value
                });
            }
        }
    }, {
        key: 'changeDate',
        value: function changeDate(val, type) {
            var newDate = Object.assign({}, this.state.returnDate);

            var validDate = false,
                end_date = '',
                formatDate = '';

            switch (type) {
                case 'dd':
                    newDate.dd = val;
                    break;
                case 'mm':
                    newDate.mm = MONTHS.indexOf(val) + 1;
                    break;
                case 'yyyy':
                    newDate.yyyy = val;
                    break;
                default:
                    '';
            }

            validDate = isValidDate(newDate);

            if (validDate) {
                formatDate = newDate.mm + '/' + newDate.dd + '/' + newDate.yyyy;
                end_date = new Date(formatDate).getTime() / 1000;
            }

            this.setState({
                endDate: validDate ? end_date : this.state.endDate,
                returnDate: newDate,
                disableSubmit: !validDate,
                errorMessage: validDate ? '' : i18n.t('out_of_office.popup.date_invalid')
            });
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this2 = this;

            var _state = this.state,
                endDate = _state.endDate,
                whyVacation = _state.whyVacation,
                buyerMessage = _state.buyerMessage,
                allowContact = _state.allowContact;


            var requestObj = {
                end_date: endDate,
                reason: whyVacation,
                message_for_buyer: buyerMessage,
                allow_contact: allowContact,
                userId: this.props.userId
            };

            submitVacation(requestObj).then(function (data) {
                if (data.status === 'success') {
                    var event = new Event('out_of_office_on');
                    document.dispatchEvent(event);

                    // in case of closing the popup from the submit we send true and e is null
                    _this2.props.close(null, _this2.state, true);
                } else {
                    throw '';
                }
            }).catch(function () {
                _this2.setState({
                    globalMessage: i18n.t('out_of_office.error.general')
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state2 = this.state,
                returnDate = _state2.returnDate,
                disableSubmit = _state2.disableSubmit,
                whyVacation = _state2.whyVacation,
                buyerMessage = _state2.buyerMessage,
                allowContact = _state2.allowContact,
                errorMessage = _state2.errorMessage,
                globalMessage = _state2.globalMessage;


            var dateClass = 'return-select' + (errorMessage.length ? ' error' : ''),
                ddClass = 'statuses-select' + (whyVacation.length ? ' is-active' : ''),
                buyerMessageStr = buyerMessage.length ? buyerMessage : ' ',
                textareaStr = external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'span',
                null,
                i18n.t('out_of_office.popup.leave_message.title'),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'span',
                    { className: 'optional' },
                    i18n.t('out_of_office.popup.optional')
                )
            ),
                selectStr = external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'span',
                null,
                i18n.t('out_of_office.popup.why_vacation.title'),
                ' ',
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'span',
                    { className: 'optional' },
                    i18n.t('out_of_office.popup.optional')
                )
            );

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                null,
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('label', { htmlFor: 'vacation-date' }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'label',
                    null,
                    i18n.t('out_of_office.popup.returning_date')
                ),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'vacation-date' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        dist["Select"],
                        { value: MONTHS[returnDate.mm - 1],
                            onChange: function onChange(event) {
                                return _this3.changeDate(event.target.value, 'mm');
                            },
                            className: dateClass },
                        MONTHS.map(function (month) {
                            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                                dist["Option"],
                                { disabled: month === 'Select', value: month, key: month },
                                month
                            );
                        })
                    ),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        dist["Select"],
                        { value: returnDate.dd,
                            onChange: function onChange(event) {
                                return _this3.changeDate(Number(event.target.value), 'dd');
                            },
                            className: dateClass },
                        DAYS.map(function (day) {
                            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                                dist["Option"],
                                { disabled: day === 'Select', value: day, key: day },
                                day
                            );
                        })
                    ),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        dist["Select"],
                        { value: returnDate.yyyy,
                            onChange: function onChange(event) {
                                return _this3.changeDate(Number(event.target.value), 'yyyy');
                            },
                            className: dateClass },
                        YEARS.map(function (year) {
                            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                                dist["Option"],
                                { disabled: year === 'Select', value: year, key: year },
                                year
                            );
                        })
                    )
                ),
                errorMessage && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'error-message' },
                    errorMessage
                ),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    dist["Select"],
                    { label: selectStr,
                        value: whyVacation,
                        onChange: function onChange(event) {
                            return _this3.changeVacationReason(event.target.value);
                        },
                        name: 'vacation_type',
                        className: ddClass },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        dist["Option"],
                        { value: '', key: 'select' },
                        i18n.t('out_of_office.popup.why_vacation.options.select')
                    ),
                    WHY_VACATION.map(function (vacationType) {
                        return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            dist["Option"],
                            { disabled: vacationType === 'Select', value: vacationType, key: vacationType },
                            i18n.t('out_of_office.popup.why_vacation.options.' + vacationType)
                        );
                    })
                ),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(dist["Textarea"], { onChange: this.changeBuyerMessage,
                    maxLength: MAX_TEXT_LENGTH,
                    value: buyerMessageStr,
                    label: textareaStr }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(dist["Checkbox"], { className: 'checkbox', onChange: this.changeAllowContact, name: 'allow_new_buyers', caption: i18n.t('out_of_office.popup.allow_new_buyers'), checked: allowContact }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'cf' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(dist["Button"], { onClick: this.submit, className: 'btn-green submit-vacation', text: 'Activate', disabled: disableSubmit }),
                    globalMessage && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'div',
                        { className: 'error-message' },
                        globalMessage
                    )
                )
            );
        }
    }]);

    return VacationForm;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["Component"]);

VacationForm_VacationForm_VacationForm.propTypes = {
    close: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func.isRequired,
    userId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number.isRequired,
    whyVacation: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    buyerMessage: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    allowContact: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool
};

VacationForm_VacationForm_VacationForm.defaultProps = {
    userId: 0,
    whyVacation: '',
    buyerMessage: '',
    allowContact: false,
    close: function close() {
        return null;
    }
};

/* harmony default export */ var VacationPopup_VacationForm_VacationForm = (VacationForm_VacationForm_VacationForm);
// EXTERNAL MODULE: ./src/index.js
var src = __webpack_require__("lVK7");

// CONCATENATED MODULE: ./src/VacationPopup/VacationPopup.js
var VacationPopup__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function VacationPopup__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function VacationPopup__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function VacationPopup__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var VacationPopup_VacationPopup_VacationPopup = function (_Component) {
    VacationPopup__inherits(VacationPopup, _Component);

    function VacationPopup(props) {
        VacationPopup__classCallCheck(this, VacationPopup);

        var _this = VacationPopup__possibleConstructorReturn(this, (VacationPopup.__proto__ || Object.getPrototypeOf(VacationPopup)).call(this, props));

        _this.state = {
            isOpen: _this.props.isOpen || false
        };

        _this.close = _this.close.bind(_this);
        return _this;
    }

    VacationPopup__createClass(VacationPopup, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {

            if (nextProps.isOpen !== this.state.isOpen) {
                this.setState({ isOpen: nextProps.isOpen });
            }
        }
    }, {
        key: 'close',
        value: function close(e, data) {
            var _this2 = this;

            var fromSubmit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (e && e.preventDefault) {
                e.preventDefault();
            }

            this.setState({
                isOpen: false
            }, function () {
                return _this2.props.closePopup(e, data, fromSubmit);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (!src["Popup"]) {
                return null;
            }

            var _props = this.props,
                dateVal = _props.dateVal,
                whyVacation = _props.whyVacation,
                buyerMessage = _props.buyerMessage,
                allowContact = _props.allowContact,
                userId = _props.userId;


            var close = this.close;

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                src["Popup"],
                { isOpen: this.state.isOpen,
                    closePopup: function closePopup(e) {
                        return _this3.close(e, null, false);
                    },
                    parent: this,
                    title: i18n.t('out_of_office.popup.title'),
                    name: 'out-of-office-popup',
                    darken: true,
                    layout: 'base',
                    noScroll: true },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(VacationPopup_VacationForm_VacationForm, { dateVal: dateVal,
                    whyVacation: whyVacation,
                    allowContact: allowContact,
                    buyerMessage: buyerMessage,
                    close: close,
                    userId: userId })
            );
        }
    }]);

    return VacationPopup;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["Component"]);

VacationPopup_VacationPopup_VacationPopup.propTypes = {
    isOpen: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    userId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number.isRequired,
    whyVacation: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    buyerMessage: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    allowContact: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    closePopup: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func.isRequired
};

VacationPopup_VacationPopup_VacationPopup.defaultProps = {
    isOpen: false,
    userId: 0,
    whyVacation: '',
    buyerMessage: '',
    allowContact: false,
    closePopup: function closePopup() {
        return null;
    }
};

/* harmony default export */ var src_VacationPopup_VacationPopup = (VacationPopup_VacationPopup_VacationPopup);
// CONCATENATED MODULE: ./src/ProfileBanner/Seller.js


var ProfileBanner_Seller_Seller = function Seller(_ref) {
    var endDate = _ref.endDate,
        buyerMessage = _ref.buyerMessage,
        openPopup = _ref.openPopup,
        isMobile = _ref.isMobile;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        "div",
        { className: "content seller-view" },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "h3",
            { className: "title" },
            i18n.t('out_of_office.banner.seller.you_are_out')
        ),
        !!endDate && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "p",
            { className: "notice" },
            i18n.t('out_of_office.banner.seller.your_gigs'),
            " ",
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                "strong",
                null,
                endDate
            ),
            !isMobile && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                "a",
                { className: "popup-link", onClick: function onClick(e) {
                        return openPopup(e, 'seller_page');
                    } },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("i", { className: "fa fa-pencil", "aria-hidden": "true" }),
                " ",
                i18n.t('out_of_office.general.edit')
            )
        ),
        buyerMessage && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "p",
            { className: "buyer-message" },
            buyerMessage
        )
    );
};

/* harmony default export */ var ProfileBanner_Seller = (ProfileBanner_Seller_Seller);
// CONCATENATED MODULE: ./src/ProfileBanner/Buyer.js


var ProfileBanner_Buyer_Buyer = function Buyer(_ref) {
    var username = _ref.username,
        endDate = _ref.endDate,
        allowContact = _ref.allowContact,
        buyerMessage = _ref.buyerMessage,
        clickContact = _ref.clickContact;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        "div",
        { className: "content buyer-view" },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "h3",
            { className: "title" },
            i18n.t('out_of_office.banner.buyer.is_out', { username: username }),
            !!endDate && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                "span",
                null,
                i18n.t('out_of_office.banner.buyer.until', { endDate: endDate })
            )
        ),
        allowContact && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "p",
            { className: "notice" },
            i18n.t('out_of_office.banner.buyer.meantime'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                "a",
                { href: "/conversations/" + username, onClick: clickContact },
                i18n.t('out_of_office.banner.buyer.contact')
            ),
            " ",
            username
        ),
        buyerMessage && buyerMessage.length && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "p",
            { className: "buyer-message" },
            buyerMessage
        )
    );
};

/* harmony default export */ var ProfileBanner_Buyer = (ProfileBanner_Buyer_Buyer);
// CONCATENATED MODULE: ./src/ProfileBanner/ProfileBanner.js
var ProfileBanner__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ProfileBanner__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ProfileBanner__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ProfileBanner__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ProfileBanner_ProfileBanner = function (_Component) {
    ProfileBanner__inherits(ProfileBanner, _Component);

    function ProfileBanner(props) {
        ProfileBanner__classCallCheck(this, ProfileBanner);

        var _this = ProfileBanner__possibleConstructorReturn(this, (ProfileBanner.__proto__ || Object.getPrototypeOf(ProfileBanner)).call(this, props));

        _this.state = {
            allowContact: props.allowContact
        };

        _this.changeAllowContact = _this.changeAllowContact.bind(_this);
        _this.clickContact = _this.clickContact.bind(_this);
        return _this;
    }

    ProfileBanner__createClass(ProfileBanner, [{
        key: 'changeAllowContact',
        value: function changeAllowContact() {
            this.setState({
                allowContact: !this.state.allowContact
            });
        }
    }, {
        key: 'clickContact',
        value: function clickContact() {
            reportEvent('contact_me.click', {
                'current_page_type': 'seller_page',
                'seller': {
                    'id': this.props.userId
                }
            }, 'conversation');
        }
    }, {
        key: 'render',
        value: function render() {
            var allowContact = this.state.allowContact;
            var _props = this.props,
                dateVal = _props.dateVal,
                isOnVacation = _props.isOnVacation,
                buyerMessage = _props.buyerMessage,
                isPageOwner = _props.isPageOwner,
                username = _props.username,
                openPopup = _props.openPopup,
                isMobile = _props.isMobile;


            var hideBannerClass = !isOnVacation ? ' hidden' : '',
                endDate = dateVal ? getDateString(dateVal) : dateVal;

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'banner profile-page cf' + hideBannerClass },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('span', { className: 'suitcase' }),
                isPageOwner ? external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(ProfileBanner_Seller, { endDate: endDate,
                    buyerMessage: buyerMessage,
                    openPopup: openPopup,
                    isMobile: isMobile }) : external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(ProfileBanner_Buyer, { endDate: endDate,
                    buyerMessage: buyerMessage,
                    allowContact: allowContact,
                    username: username,
                    clickContact: this.clickContact })
            );
        }
    }]);

    return ProfileBanner;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["Component"]);

ProfileBanner_ProfileBanner.propTypes = {
    allowContact: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    isPageOwner: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    dateVal: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number,
    buyerMessage: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    isOnVacation: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool
};

ProfileBanner_ProfileBanner.defaultProps = {
    allowContact: false,
    isPageOwner: false,
    isOnVacation: false,
    buyerMessage: ''
};

/* harmony default export */ var src_ProfileBanner_ProfileBanner = (ProfileBanner_ProfileBanner);
// EXTERNAL MODULE: external "@fiverr/globals"
var globals_ = __webpack_require__("E4I8");
var globals__default = /*#__PURE__*/__webpack_require__.n(globals_);

// EXTERNAL MODULE: ./src/index.scss
var src_0 = __webpack_require__("iCOP");
var src_default = /*#__PURE__*/__webpack_require__.n(src_0);

// CONCATENATED MODULE: ./src/OutOfOffice.js
var OutOfOffice__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var OutOfOffice__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function OutOfOffice__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OutOfOffice__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function OutOfOffice__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var OutOfOffice_OutOfOffice = function (_PureComponent) {
    OutOfOffice__inherits(OutOfOffice, _PureComponent);

    function OutOfOffice(props) {
        OutOfOffice__classCallCheck(this, OutOfOffice);

        var _this = OutOfOffice__possibleConstructorReturn(this, (OutOfOffice.__proto__ || Object.getPrototypeOf(OutOfOffice)).call(this, props));

        i18n.add(translations_en_default.a);

        _this.state = {
            isOpen: false,
            dateVal: 0,
            buyerMessage: props.message_for_buyer,
            allowContact: props.allow_contact,
            whyVacation: props.reason,
            isOnVacation: props.is_on_vacation,
            isPageOwner: props.is_page_owner
        };

        _this.openPopup = _this.openPopup.bind(_this);
        _this.submitAllVacationDetails = _this.submitAllVacationDetails.bind(_this);
        _this.closePopup = _this.closePopup.bind(_this);
        _this.turnOff = _this.turnOff.bind(_this);
        _this.updateDate = _this.updateDate.bind(_this);
        return _this;
    }

    OutOfOffice__createClass(OutOfOffice, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.updateDate();

            document.addEventListener('open_popup', function (e) {
                if (e.detail) {
                    _this2.openPopup(e);
                    return;
                }

                _this2.setState({ isOnVacation: e.detail });

                reportEvent('click_off', {
                    'current_page_type': 'seller_page',
                    'seller': {
                        'id': _this2.props.user_id
                    }
                });
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('open_popup', this.openPopup);
        }
    }, {
        key: 'updateDate',
        value: function updateDate() {
            this.setState({ dateVal: this.props.end_date });
        }
    }, {
        key: 'submitAllVacationDetails',
        value: function submitAllVacationDetails(data) {
            this.setState({
                dateVal: data.endDate,
                buyerMessage: data.buyerMessage,
                allowContact: data.allowContact,
                whyVacation: data.whyVacation,
                isOnVacation: true,
                isPageOwner: true
            });
        }
    }, {
        key: 'openPopup',
        value: function openPopup(e) {
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            e && e.preventDefault();

            // BI event
            type ? reportEvent('click_edit', { current_page_type: type }) : reportEvent('click_on');

            this.setState({
                isOpen: true
            });
        }
    }, {
        key: 'closePopup',
        value: function closePopup(e, data) {
            var fromSubmit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            // closed without submit
            if (!fromSubmit) {

                // in case of ooo off close the toggle.
                if (!this.state.isOnVacation) {
                    var event = new CustomEvent('popup_close', { detail: false });
                    document.dispatchEvent(event);
                }
            } else if (e && e.preventDefault) {
                e.preventDefault();
            }

            data && this.submitAllVacationDetails(data);

            this.setState({
                isOpen: false
            });
        }
    }, {
        key: 'turnOff',
        value: function turnOff() {
            var _this3 = this;

            turnVacationOff(this.props.username).then(function () {
                _this3.setState({
                    isOnVacation: false
                }, function () {
                    return _this3.closePopup(null, null, false);
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                profile_image_url = _props.profile_image_url,
                type = _props.type,
                user_id = _props.user_id,
                gig_id = _props.gig_id,
                username = _props.username,
                isMobileResponsive = _props.isMobileResponsive;


            var Banner = type === 'profile' ? src_ProfileBanner_ProfileBanner : src_GigBanner_GigBanner,
                isMobilePS = !!Fiverr.models && !!Fiverr.models.ps ? !!Fiverr.models.ps.isMobileResponsive : false,
                isMobile = typeof isMobileResponsive !== 'undefined' ? isMobileResponsive : isMobilePS;

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'out-of-office' },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(Banner, OutOfOffice__extends({}, this.state, {
                    profileImageUrl: profile_image_url,
                    userId: user_id,
                    gigId: gig_id,
                    username: username,
                    openPopup: this.openPopup,
                    turnOff: this.turnOff,
                    isMobile: isMobile })),
                this.state.isOpen && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(src_VacationPopup_VacationPopup, OutOfOffice__extends({}, this.state, {
                    userId: user_id,
                    closePopup: this.closePopup }))
            );
        }
    }]);

    return OutOfOffice;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

OutOfOffice_OutOfOffice.propTypes = {
    type: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string.isRequired,
    is_page_owner: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    user_id: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number.isRequired,
    gig_id: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number,
    end_date: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number,
    reason: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    allow_contact: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    message_for_buyer: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

OutOfOffice_OutOfOffice.defaultProps = {
    type: 'profile',
    user_id: 0,
    gig_id: 0,
    is_on_vacation: false,
    is_page_owner: false,
    isOpen: false,
    allow_contact: false
};

/* harmony default export */ var src_OutOfOffice = __webpack_exports__["a"] = (OutOfOffice_OutOfOffice);

/***/ }),

/***/ "wLXD":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_wLXD__;

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// index.66152d7307d576cf9dd1.js